import { useState } from "react";
import { motion } from "framer-motion";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import ServicesSection from "@/components/ServicesSection";
import WhyRenovateSection from "@/components/WhyRenovateSection";
import AboutSection from "@/components/AboutSection";
import TestimonialsSection from "@/components/TestimonialsSection";
import ContactSection from "@/components/ContactSection";
import BookingModal from "@/components/BookingModal";
import Footer from "@/components/Footer";

export default function LandingPage() {
  const [isBookingOpen, setIsBookingOpen] = useState(false);

  return (
    <div className="min-h-screen bg-background relative grain-overlay">
      <Navbar onBookingClick={() => setIsBookingOpen(true)} />
      
      <main>
        <HeroSection onBookingClick={() => setIsBookingOpen(true)} />
        <ServicesSection />
        <WhyRenovateSection onBookingClick={() => setIsBookingOpen(true)} />
        <AboutSection />
        <TestimonialsSection />
        <ContactSection />
      </main>

      <Footer />
      
      <BookingModal 
        isOpen={isBookingOpen} 
        onClose={() => setIsBookingOpen(false)} 
      />
    </div>
  );
}
